import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceSendActivityReportNotificationState = createStateReducer(
  initialState,
  {
    [events.sendActivityReportSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "sendActivityReport",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.sendActivityReportFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "sendActivityReport",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceSendActivityReportNotificationState };
